/*
 * common utils
 */

import {PET_NECKLACE_ID} from '../model/model';

export const ua = window.navigator.userAgent;

export const locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

export let isIE = (function () {
  return /msie/i.test(ua) || /trident/i.test(ua);
}());

export let isEdge = (userAgent) => {
  return ( /Gecko/i.test(userAgent) && /Edge/i.test(userAgent) );
};

export let isOpera = (userAgent) => {
  return ( /Opera/i.test(userAgent) || /OPR\//i.test(userAgent) );
};

export let isChrome = (userAgent) => {
  return ( !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent) );
};

export let isIOS = (userAgent) => {
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export let isAndroid = (userAgent) => {
  return /android/i.test(userAgent);
};

export let truthy = function truthy(object) {
  return !!object;
};

export let falsy = function falsy(object) {
  return !!!object;
};

export let existy = (obj) => {
  return obj != null;
};

export let isDefined = (obj) => {
  let flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

export let isRc = (function () {
  return isDefined(/^rc-/.exec(location.hostname));
}());

export let isInteger = (obj) => {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return (isFinite(obj) && Math.floor(obj) === obj);
};

export let isString = (obj) => {
  if (!isDefined(obj)) return false;
  return (obj.constructor === String);
};

export let isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return (obj.constructor === Number);
};

export let isBoolean = (obj) => {
  if (!isDefined(obj)) return false;
  return (obj.constructor === Boolean);
};

export let isObject = (obj) => {
  if (!isDefined(obj)) return false;
  return (obj.constructor === Object);
};

export let isFunction = (obj) => {
  if (!isDefined(obj)) return false;
  return (obj.constructor === Function);
};

export let isRegExp = (obj) => {
  if (!isDefined(obj)) return false;
  return (obj.constructor === RegExp);
};

export let not = (func) => {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return (object) => {
    return !func(object);
  };
};

export let isNotDefined = not(isDefined);

export let parseInt10 = (number) => {
  return parseInt(number, 10);
};

export let parseStrIntToInt = (strIntOrInt) => {
  let val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof(val) === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

export let removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
    index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

export let allOf = function allOf(/*args*/) {
  const args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return (val === true);
  });
};

export let anyOf = function anyOf(/*args*/) {
  const args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return (val === true);
  });
};

export let getDefined = function (val, defaultVal) {
  return (isDefined(val)) ? val : defaultVal;
};

export let notSingleEle = not(($ele) => {
  return $ele.length === 1;
});

export let each = (dataCanLoop, func, context) => {
  let _context = (existy(context)) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  let result = false;
  for (let i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

export let getFileExtension = (fileName) => {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
    extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

export let getFirstObjectHasProperty = function (arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  let obj, result = null;
  for (let i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

export let getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey ) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  let obj, result = null;

  each(arrayHasObjects, (obj) => {
    if(obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};


export let overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  let datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  let conditionIndex = (_conditionIndex >= 0) ? _conditionIndex : 0,
    condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    let prevProperty = condition.property,
      nextConditionIndex = conditionIndex + 1,
      nextCondition = _conditions[nextConditionIndex];

    let memoObj = {},
      memoArr = [],
      arr = [];

    let obj, prop;
    for (let i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (let j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    let resultArr = memoArr.reduce((acc, curVal, curIndex, array) => acc.concat(curVal));

    return resultArr;
  }

  return datas;
}


export let getPositionFromTranslateStr = (str) => {
  let obj = {x: 0, y: 0};
  if (!isDefined(str)) return obj;

  let values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

export let isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  const args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  let index = firstIndex;
  for (let i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = (index + 1 > totalLength) ? 1 : index + 1;
  }

  return false;
};

export let getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  const args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  let index = firstIndex;
  for (let i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

export let getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  const args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  let index = lastIndex;
  for (let i = 0; i < loopGap - 1; i++) {
    index = (index - 1 < 1) ? totalLength : index - 1;
  }

  return index;
};

export let getResolution = (breakpoint = {tablet: 640, pc: 960, max: 1260}, global = window) => {
  let resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';

  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';

  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';

  } else {
    resolution = 'phone';
  }

  return resolution;
};

export let isPhoneResolution = (resolution) => {
  return resolution === 'phone';
};

export let isTabletResolution = (resolution) => {
  return resolution === 'tablet';
};

export let isMobileResolution = (resolution) => {
  return ( resolution === 'phone' || resolution === 'tablet');
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export let numberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export let getUriParams = (uri) => {
  if (uri.length < 1) return null;
  let str = uri.split('#')[0];

  let tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  let paramStr = tmpArr[1],
    params = paramStr.split('&');

  let keyValueArr, obj = {};
  for (let i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

export let getUriCombinedParams = (uri, params) => {
  if (!uri) return '';
  if (!params) return uri;

  let str = '';
  for (let key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
    uri = tmpArr[0],
    hashStr = (isDefined(tmpArr[1])) ? '#' + tmpArr[1] : '';

  uri = ((uri.indexOf('?') >= 0) ? (uri + str) : (uri + '?' + str.substr(1))) + hashStr;
  return uri;
};

export let getHashParams = (hashStr) => {
  let str = hashStr;
  if (str.length < 1) return null;

  let tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  let paramStr = tmpArr[1],
    params = paramStr.split('&');

  let keyValueArr, obj = {};
  for (let i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

export let getHashCombinedParams = (uri, params) => {
  if (!params) return uri;

  let str = '';
  for (let key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = (uri.indexOf('#') >= 0) ? (uri + str) : (uri + '#' + str.substr(1));
  return uri;
};

export let getObjForPagination = function (totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  const args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  let totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  let paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
    prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
    firstPageIndex = (paginationBtnGroupIndex * displayPaginationBtnNum) + 1,
    lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
    nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

export let getDivideIntStrByThousandUnit = (intStr_) => {
  if (not(isDefined)(intStr_)) return ['0'];

  const DIVIDE_UNIT = 4;

  let intStr = String(parseStrIntToInt(intStr_)),
    intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  let lastIndex = 0, unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

export let getMarketPriceStr = (str) => {
  const UNIT_PRICE = ['', '만', '억'];

  let val = ( isDefined(str) ) ? str : '0',
    unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  let priceStr = '', unitVal = 0;
  for (let i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = (numberWithCommas(unitVal) + UNIT_PRICE[i]) + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

export let getEmphasizedStrByQuery = (str, query) => {
  return (str || '').split(query).join(`<strong>${query}</strong>`);
};

export let getSeparatedDateStr = (moment, dateStr, DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
}) => {
  let val = '';

  const MIN_TO_SEC = 60,
    HOUR_TO_SEC = 3600,
    DAY_TO_SEC = 86400;

  const now = new Date(),
    past = new Date(dateStr),
    diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = `${diffSeconds}초 전`;

      } else {
        const diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = `${diffMinutes}분 전`;
      }

    } else {
      const diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = `${diffHours}시간 전`;
    }

  } else {
    const date = moment(dateStr),
      day = (DAYS[date.format('dddd')] || '');

    val = date.format(`YYYY-MM-DD`);
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

export let namespace = (namespace, parent) => {
  if (!isString(namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  let ns = parent || window;

  if (namespace) {
    let parts = namespace.split('.');

    for (let i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

export let template = function template(strings, ...keys) {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return (function (...values) {
    let dict = values[values.length - 1] || {};

    let result = [strings[0]];
    keys.forEach(function (key, i) {
      let value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  });
};

// board - server list
export let getUrlAddCategoryIdByArticle = function(_url, _article, _serverNameMap) {
  let url = _url;

  if (url !== '#') {
    const path = url.split('?')[0],
      uriParams = getUriParams(url);

    let categoryId = (isObject(_article.category)) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, {categoryId: categoryId}));
  }

  return url;
}

// character setting - stat, equip simulator
export let getChangedStats = function (originalStatObj, newStatObj) {
  let changedStats = {};

  var stat, newStat;
  for (let key in originalStatObj) {
    stat = (isDefined(originalStatObj[key])) ? originalStatObj[key] : null;
    newStat = (isDefined(newStatObj[key])) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  let changeStatsCount = 0;
  for (let k in changedStats) changeStatsCount++;

  return (changeStatsCount > 0) ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
export let getPlusElixirPointByLevel = function (level, level_init, plusElixirPointByLevel ) {
  let _plusElixirPoint = 0;
  if ( (level - level_init) % 2 === 0 ) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, (obj) => {
    if( parseInt(obj.level) === parseInt(level) ) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
export let isLevelCanConsumeElixirStat = function (level, perLevelPlusElixirPoint) {
  return (level >=  0) ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

export let isLevelGetElixirPoint = function (level, perLevelPlusElixirPoint) { // 2019.11
  return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

// STAT_MAX_BY_LEVEL 2021.
export let getStatMaxByLevel = function (level, statMaxByLevel ) {
  let _statMax = 50;
  each(statMaxByLevel, (obj) => {
    if (parseInt(obj.level) <= level) {
      _statMax = parseInt(obj.max);
    }
  });
  // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
  return _statMax;
};

export let isWarrior = function (classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
}

export let getClassName = function (classId) {
  const CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사'];

  let className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

export let removeEquipInEquips = function (equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  const clonedEquips = equips.slice();

  let equip;
  for (let i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

export const isPetNecklace = function(itemId) {
  return (itemId === PET_NECKLACE_ID) ? true : false;
};


// WEBPACK FOOTER //
// ./_src/js/utils/util.js